import { AddRecordCollectionAction } from '../../redux/collection-reducer';
import { KeyTaxDirective } from '../reducer';
import { ADD_KEY_TAX_DIRECTIVE } from '../views/key-tax-directive/types';

export type AddKeyTaxDirectiveAction = AddRecordCollectionAction<KeyTaxDirective>;

export const addKeyTaxDirectiveActionCreator = (
    addKayTaxDirective: KeyTaxDirective
): AddKeyTaxDirectiveAction => {
    return {
        type: ADD_KEY_TAX_DIRECTIVE,
        record: addKayTaxDirective,
    };
};
